module.exports = __webpack_public_path__ + "img/symbol_5.a9adc8bd.png";